import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'highligthSearchText' })
export class HighligthSearchText implements PipeTransform {
  transform(currentText: string, currentSearch: string) {
    const reg = new RegExp(currentSearch, 'gi')
    if(currentText.search(reg) !== -1 && currentSearch !== ''){
      return currentText.replace(reg, `<span class="highligthText">${currentSearch}</span>`)
    }else{
      return currentText
    }
  }
}
